/* Generated by scripts/generate-types.js */
export const IconNames = [
  "a-arrow-down",
  "a-arrow-up",
  "a-large-small",
  "accessibility",
  "activity",
  "activity-square",
  "ad",
  "air-vent",
  "airplay",
  "alarm-check",
  "alarm-clock",
  "alarm-clock-check",
  "alarm-clock-minus",
  "alarm-clock-off",
  "alarm-clock-plus",
  "alarm-minus",
  "alarm-plus",
  "alarm-smoke",
  "album",
  "alert-circle",
  "alert-octagon",
  "alert-triangle",
  "align-center",
  "align-center-horizontal",
  "align-center-vertical",
  "align-end-horizontal",
  "align-end-vertical",
  "align-horizontal-distribute-center",
  "align-horizontal-distribute-end",
  "align-horizontal-distribute-start",
  "align-horizontal-justify-center",
  "align-horizontal-justify-end",
  "align-horizontal-justify-start",
  "align-horizontal-space-around",
  "align-horizontal-space-between",
  "align-justify",
  "align-left",
  "align-right",
  "align-start-horizontal",
  "align-start-vertical",
  "align-vertical-distribute-center",
  "align-vertical-distribute-end",
  "align-vertical-distribute-start",
  "align-vertical-justify-center",
  "align-vertical-justify-end",
  "align-vertical-justify-start",
  "align-vertical-space-around",
  "align-vertical-space-between",
  "ambulance",
  "ampersand",
  "ampersands",
  "amphora",
  "anchor",
  "angry",
  "annoyed",
  "antenna",
  "anvil",
  "aperture",
  "app-window",
  "app-window-mac",
  "apple",
  "archive",
  "archive-restore",
  "archive-x",
  "area-chart",
  "armchair",
  "arrow-big-down",
  "arrow-big-down-dash",
  "arrow-big-left",
  "arrow-big-left-dash",
  "arrow-big-right",
  "arrow-big-right-dash",
  "arrow-big-up",
  "arrow-big-up-dash",
  "arrow-down",
  "arrow-down-0-1",
  "arrow-down-01",
  "arrow-down-1-0",
  "arrow-down-10",
  "arrow-down-a-z",
  "arrow-down-az",
  "arrow-down-circle",
  "arrow-down-from-line",
  "arrow-down-left",
  "arrow-down-left-from-circle",
  "arrow-down-left-from-square",
  "arrow-down-left-square",
  "arrow-down-narrow-wide",
  "arrow-down-right",
  "arrow-down-right-from-circle",
  "arrow-down-right-from-square",
  "arrow-down-right-square",
  "arrow-down-square",
  "arrow-down-to-dot",
  "arrow-down-to-line",
  "arrow-down-up",
  "arrow-down-wide-narrow",
  "arrow-down-z-a",
  "arrow-down-za",
  "arrow-left",
  "arrow-left-circle",
  "arrow-left-from-line",
  "arrow-left-right",
  "arrow-left-square",
  "arrow-left-to-line",
  "arrow-right",
  "arrow-right-circle",
  "arrow-right-from-line",
  "arrow-right-left",
  "arrow-right-square",
  "arrow-right-to-line",
  "arrow-up",
  "arrow-up-0-1",
  "arrow-up-01",
  "arrow-up-1-0",
  "arrow-up-10",
  "arrow-up-a-z",
  "arrow-up-az",
  "arrow-up-circle",
  "arrow-up-down",
  "arrow-up-from-dot",
  "arrow-up-from-line",
  "arrow-up-left",
  "arrow-up-left-from-circle",
  "arrow-up-left-from-square",
  "arrow-up-left-square",
  "arrow-up-narrow-wide",
  "arrow-up-right",
  "arrow-up-right-from-circle",
  "arrow-up-right-from-square",
  "arrow-up-right-square",
  "arrow-up-square",
  "arrow-up-to-line",
  "arrow-up-wide-narrow",
  "arrow-up-z-a",
  "arrow-up-za",
  "arrows-up-from-line",
  "asterisk",
  "asterisk-square",
  "astroid",
  "at-sign",
  "atom",
  "audio-lines",
  "audio-waveform",
  "award",
  "axe",
  "axis-3-d",
  "axis-3d",
  "baby",
  "backpack",
  "badge",
  "badge-alert",
  "badge-cent",
  "badge-check",
  "badge-dollar-sign",
  "badge-euro",
  "badge-help",
  "badge-indian-rupee",
  "badge-info",
  "badge-japanese-yen",
  "badge-minus",
  "badge-percent",
  "badge-plus",
  "badge-pound-sterling",
  "badge-question-mark",
  "badge-russian-ruble",
  "badge-swiss-franc",
  "badge-turkish-lira",
  "badge-x",
  "baggage-claim",
  "balloon",
  "ban",
  "banana",
  "bandage",
  "banknote",
  "banknote-arrow-down",
  "banknote-arrow-up",
  "banknote-check",
  "banknote-x",
  "bar-chart",
  "bar-chart-2",
  "bar-chart-3",
  "bar-chart-4",
  "bar-chart-big",
  "bar-chart-horizontal",
  "bar-chart-horizontal-big",
  "barcode",
  "barrel",
  "baseline",
  "bath",
  "battery",
  "battery-charging",
  "battery-full",
  "battery-low",
  "battery-medium",
  "battery-plus",
  "battery-warning",
  "beaker",
  "bean",
  "bean-off",
  "bed",
  "bed-double",
  "bed-single",
  "beef",
  "beef-off",
  "beer",
  "beer-off",
  "bell",
  "bell-check",
  "bell-dot",
  "bell-electric",
  "bell-minus",
  "bell-off",
  "bell-plus",
  "bell-ring",
  "between-horizonal-end",
  "between-horizonal-start",
  "between-horizontal-end",
  "between-horizontal-start",
  "between-vertical-end",
  "between-vertical-start",
  "biceps-flexed",
  "bike",
  "binary",
  "binoculars",
  "biohazard",
  "bird",
  "birdhouse",
  "bitcoin",
  "blend",
  "blender",
  "blinds",
  "blocks",
  "bluetooth",
  "bluetooth-connected",
  "bluetooth-off",
  "bluetooth-searching",
  "bold",
  "bolt",
  "bomb",
  "bone",
  "bone-fracture",
  "book",
  "book-a",
  "book-alert",
  "book-audio",
  "book-check",
  "book-copy",
  "book-dashed",
  "book-down",
  "book-headphones",
  "book-heart",
  "book-image",
  "book-key",
  "book-lock",
  "book-marked",
  "book-minus",
  "book-open",
  "book-open-check",
  "book-open-text",
  "book-plus",
  "book-search",
  "book-template",
  "book-text",
  "book-type",
  "book-up",
  "book-up-2",
  "book-user",
  "book-x",
  "bookmark",
  "bookmark-check",
  "bookmark-minus",
  "bookmark-off",
  "bookmark-plus",
  "bookmark-x",
  "boom-box",
  "bot",
  "bot-message-square",
  "bot-off",
  "bottle-wine",
  "bow-arrow",
  "box",
  "box-select",
  "boxes",
  "braces",
  "brackets",
  "brain",
  "brain-circuit",
  "brain-cog",
  "brick-wall",
  "brick-wall-fire",
  "brick-wall-shield",
  "briefcase",
  "briefcase-business",
  "briefcase-conveyor-belt",
  "briefcase-medical",
  "bring-to-front",
  "broccoli",
  "brush",
  "brush-cleaning",
  "bubbles",
  "bug",
  "bug-off",
  "bug-play",
  "building",
  "building-2",
  "bus",
  "bus-front",
  "cable",
  "cable-car",
  "cake",
  "cake-slice",
  "calculator",
  "calendar",
  "calendar-1",
  "calendar-arrow-down",
  "calendar-arrow-up",
  "calendar-check",
  "calendar-check-2",
  "calendar-clock",
  "calendar-cog",
  "calendar-days",
  "calendar-fold",
  "calendar-heart",
  "calendar-minus",
  "calendar-minus-2",
  "calendar-off",
  "calendar-plus",
  "calendar-plus-2",
  "calendar-range",
  "calendar-search",
  "calendar-sync",
  "calendar-x",
  "calendar-x-2",
  "calendars",
  "camera",
  "camera-off",
  "candlestick-chart",
  "candy",
  "candy-cane",
  "candy-off",
  "cannabis",
  "cannabis-off",
  "captions",
  "captions-off",
  "car",
  "car-front",
  "car-taxi-front",
  "caravan",
  "card-sim",
  "carrot",
  "case-lower",
  "case-sensitive",
  "case-upper",
  "cassette-tape",
  "cast",
  "castle",
  "cat",
  "cctv",
  "cctv-off",
  "chart-area",
  "chart-bar",
  "chart-bar-big",
  "chart-bar-decreasing",
  "chart-bar-increasing",
  "chart-bar-stacked",
  "chart-candlestick",
  "chart-column",
  "chart-column-big",
  "chart-column-decreasing",
  "chart-column-increasing",
  "chart-column-stacked",
  "chart-gantt",
  "chart-line",
  "chart-network",
  "chart-no-axes-column",
  "chart-no-axes-column-decreasing",
  "chart-no-axes-column-increasing",
  "chart-no-axes-combined",
  "chart-no-axes-gantt",
  "chart-pie",
  "chart-scatter",
  "chart-spline",
  "check",
  "check-check",
  "check-circle",
  "check-circle-2",
  "check-line",
  "check-square",
  "check-square-2",
  "chef-hat",
  "cherry",
  "chess-bishop",
  "chess-king",
  "chess-knight",
  "chess-pawn",
  "chess-queen",
  "chess-rook",
  "chevron-down",
  "chevron-down-circle",
  "chevron-down-square",
  "chevron-first",
  "chevron-last",
  "chevron-left",
  "chevron-left-circle",
  "chevron-left-square",
  "chevron-right",
  "chevron-right-circle",
  "chevron-right-square",
  "chevron-up",
  "chevron-up-circle",
  "chevron-up-square",
  "chevrons-down",
  "chevrons-down-up",
  "chevrons-left",
  "chevrons-left-right",
  "chevrons-left-right-ellipsis",
  "chevrons-right",
  "chevrons-right-left",
  "chevrons-up",
  "chevrons-up-down",
  "church",
  "cigarette",
  "cigarette-off",
  "circle",
  "circle-alert",
  "circle-arrow-down",
  "circle-arrow-left",
  "circle-arrow-out-down-left",
  "circle-arrow-out-down-right",
  "circle-arrow-out-up-left",
  "circle-arrow-out-up-right",
  "circle-arrow-right",
  "circle-arrow-up",
  "circle-check",
  "circle-check-big",
  "circle-chevron-down",
  "circle-chevron-left",
  "circle-chevron-right",
  "circle-chevron-up",
  "circle-dashed",
  "circle-divide",
  "circle-dollar-sign",
  "circle-dot",
  "circle-dot-dashed",
  "circle-ellipsis",
  "circle-equal",
  "circle-euro",
  "circle-fading-arrow-up",
  "circle-fading-plus",
  "circle-gauge",
  "circle-help",
  "circle-minus",
  "circle-off",
  "circle-parking",
  "circle-parking-off",
  "circle-pause",
  "circle-percent",
  "circle-pile",
  "circle-play",
  "circle-plus",
  "circle-pound-sterling",
  "circle-power",
  "circle-question-mark",
  "circle-slash",
  "circle-slash-2",
  "circle-slashed",
  "circle-small",
  "circle-star",
  "circle-stop",
  "circle-user",
  "circle-user-round",
  "circle-x",
  "circuit-board",
  "citrus",
  "clapperboard",
  "clipboard",
  "clipboard-check",
  "clipboard-clock",
  "clipboard-copy",
  "clipboard-edit",
  "clipboard-list",
  "clipboard-minus",
  "clipboard-paste",
  "clipboard-pen",
  "clipboard-pen-line",
  "clipboard-plus",
  "clipboard-signature",
  "clipboard-type",
  "clipboard-x",
  "clock",
  "clock-1",
  "clock-10",
  "clock-11",
  "clock-12",
  "clock-2",
  "clock-3",
  "clock-4",
  "clock-5",
  "clock-6",
  "clock-7",
  "clock-8",
  "clock-9",
  "clock-alert",
  "clock-arrow-down",
  "clock-arrow-left",
  "clock-arrow-right",
  "clock-arrow-up",
  "clock-check",
  "clock-fading",
  "clock-plus",
  "closed-caption",
  "cloud",
  "cloud-alert",
  "cloud-backup",
  "cloud-check",
  "cloud-cog",
  "cloud-download",
  "cloud-drizzle",
  "cloud-fog",
  "cloud-hail",
  "cloud-lightning",
  "cloud-moon",
  "cloud-moon-rain",
  "cloud-off",
  "cloud-rain",
  "cloud-rain-wind",
  "cloud-snow",
  "cloud-sun",
  "cloud-sun-rain",
  "cloud-sync",
  "cloud-upload",
  "cloudy",
  "clover",
  "club",
  "code",
  "code-2",
  "code-square",
  "code-xml",
  "coffee",
  "cog",
  "coins",
  "columns",
  "columns-2",
  "columns-3",
  "columns-3-cog",
  "columns-4",
  "columns-settings",
  "combine",
  "command",
  "compass",
  "component",
  "computer",
  "concierge-bell",
  "cone",
  "construction",
  "contact",
  "contact-2",
  "contact-round",
  "container",
  "contrast",
  "cookie",
  "cooking-pot",
  "copy",
  "copy-check",
  "copy-minus",
  "copy-plus",
  "copy-slash",
  "copy-x",
  "copyleft",
  "copyright",
  "corner-down-left",
  "corner-down-right",
  "corner-left-down",
  "corner-left-up",
  "corner-right-down",
  "corner-right-up",
  "corner-up-left",
  "corner-up-right",
  "cpu",
  "creative-commons",
  "credit-card",
  "croissant",
  "crop",
  "cross",
  "crosshair",
  "crown",
  "cuboid",
  "cup-soda",
  "curly-braces",
  "currency",
  "cylinder",
  "dam",
  "database",
  "database-arrow-down",
  "database-arrow-up",
  "database-backup",
  "database-check",
  "database-minus",
  "database-plus",
  "database-search",
  "database-x",
  "database-zap",
  "decimals-arrow-left",
  "decimals-arrow-right",
  "delete",
  "dessert",
  "diameter",
  "diamond",
  "diamond-minus",
  "diamond-percent",
  "diamond-plus",
  "dice-1",
  "dice-2",
  "dice-3",
  "dice-4",
  "dice-5",
  "dice-6",
  "dices",
  "diff",
  "disc",
  "disc-2",
  "disc-3",
  "disc-album",
  "divide",
  "divide-circle",
  "divide-square",
  "dna",
  "dna-off",
  "dock",
  "dog",
  "dollar-sign",
  "donut",
  "door-closed",
  "door-closed-locked",
  "door-open",
  "dot",
  "dot-square",
  "download",
  "download-cloud",
  "drafting-compass",
  "drama",
  "drill",
  "drone",
  "droplet",
  "droplet-off",
  "droplets",
  "drum",
  "drumstick",
  "dumbbell",
  "ear",
  "ear-off",
  "earth",
  "earth-lock",
  "eclipse",
  "edit",
  "edit-2",
  "edit-3",
  "egg",
  "egg-fried",
  "egg-off",
  "ellipse",
  "ellipsis",
  "ellipsis-vertical",
  "equal",
  "equal-approximately",
  "equal-not",
  "equal-square",
  "eraser",
  "ethernet-port",
  "euro",
  "ev-charger",
  "expand",
  "external-link",
  "eye",
  "eye-closed",
  "eye-dashed",
  "eye-off",
  "factory",
  "fan",
  "fast-forward",
  "feather",
  "fence",
  "ferris-wheel",
  "file",
  "file-archive",
  "file-audio",
  "file-audio-2",
  "file-axis-3-d",
  "file-axis-3d",
  "file-badge",
  "file-badge-2",
  "file-bar-chart",
  "file-bar-chart-2",
  "file-box",
  "file-braces",
  "file-braces-corner",
  "file-chart-column",
  "file-chart-column-increasing",
  "file-chart-line",
  "file-chart-pie",
  "file-check",
  "file-check-2",
  "file-check-corner",
  "file-clock",
  "file-code",
  "file-code-2",
  "file-code-corner",
  "file-cog",
  "file-cog-2",
  "file-diff",
  "file-digit",
  "file-down",
  "file-edit",
  "file-exclamation-point",
  "file-headphone",
  "file-heart",
  "file-image",
  "file-input",
  "file-json",
  "file-json-2",
  "file-key",
  "file-key-2",
  "file-line-chart",
  "file-lock",
  "file-lock-2",
  "file-minus",
  "file-minus-2",
  "file-minus-corner",
  "file-music",
  "file-output",
  "file-pen",
  "file-pen-line",
  "file-pie-chart",
  "file-play",
  "file-plus",
  "file-plus-2",
  "file-plus-corner",
  "file-question",
  "file-question-mark",
  "file-scan",
  "file-search",
  "file-search-2",
  "file-search-corner",
  "file-signal",
  "file-signature",
  "file-sliders",
  "file-spreadsheet",
  "file-stack",
  "file-symlink",
  "file-terminal",
  "file-text",
  "file-type",
  "file-type-2",
  "file-type-corner",
  "file-up",
  "file-user",
  "file-video",
  "file-video-2",
  "file-video-camera",
  "file-volume",
  "file-volume-2",
  "file-warning",
  "file-x",
  "file-x-2",
  "file-x-corner",
  "files",
  "film",
  "filter",
  "filter-x",
  "fingerprint",
  "fingerprint-pattern",
  "fire-extinguisher",
  "fish",
  "fish-off",
  "fish-symbol",
  "fishing-hook",
  "fishing-rod",
  "flag",
  "flag-off",
  "flag-triangle-left",
  "flag-triangle-right",
  "flame",
  "flame-kindling",
  "flashlight",
  "flashlight-off",
  "flask-conical",
  "flask-conical-off",
  "flask-round",
  "flip-horizontal",
  "flip-horizontal-2",
  "flip-vertical",
  "flip-vertical-2",
  "flower",
  "flower-2",
  "focus",
  "fold-horizontal",
  "fold-vertical",
  "folder",
  "folder-archive",
  "folder-bookmark",
  "folder-check",
  "folder-clock",
  "folder-closed",
  "folder-code",
  "folder-cog",
  "folder-cog-2",
  "folder-dot",
  "folder-down",
  "folder-edit",
  "folder-git",
  "folder-git-2",
  "folder-heart",
  "folder-input",
  "folder-kanban",
  "folder-key",
  "folder-lock",
  "folder-minus",
  "folder-open",
  "folder-open-dot",
  "folder-output",
  "folder-pen",
  "folder-plus",
  "folder-root",
  "folder-search",
  "folder-search-2",
  "folder-symlink",
  "folder-sync",
  "folder-tree",
  "folder-up",
  "folder-x",
  "folders",
  "footprints",
  "fork-knife",
  "fork-knife-crossed",
  "forklift",
  "form",
  "form-input",
  "forward",
  "frame",
  "frown",
  "fuel",
  "fullscreen",
  "function-square",
  "funnel",
  "funnel-plus",
  "funnel-x",
  "gallery-horizontal",
  "gallery-horizontal-end",
  "gallery-thumbnails",
  "gallery-vertical",
  "gallery-vertical-end",
  "gamepad",
  "gamepad-2",
  "gamepad-directional",
  "gantt-chart",
  "gantt-chart-square",
  "gauge",
  "gauge-circle",
  "gavel",
  "gem",
  "georgian-lari",
  "ghost",
  "gift",
  "git-branch",
  "git-branch-minus",
  "git-branch-plus",
  "git-commit",
  "git-commit-horizontal",
  "git-commit-vertical",
  "git-compare",
  "git-compare-arrows",
  "git-fork",
  "git-graph",
  "git-merge",
  "git-merge-conflict",
  "git-pull-request",
  "git-pull-request-arrow",
  "git-pull-request-closed",
  "git-pull-request-create",
  "git-pull-request-create-arrow",
  "git-pull-request-draft",
  "glass-water",
  "glasses",
  "globe",
  "globe-2",
  "globe-check",
  "globe-lock",
  "globe-off",
  "globe-x",
  "goal",
  "gpu",
  "grab",
  "graduation-cap",
  "grape",
  "grid",
  "grid-2-x-2",
  "grid-2-x-2-check",
  "grid-2-x-2-plus",
  "grid-2-x-2-x",
  "grid-2x2",
  "grid-2x2-check",
  "grid-2x2-plus",
  "grid-2x2-x",
  "grid-3-x-3",
  "grid-3x2",
  "grid-3x3",
  "grip",
  "grip-horizontal",
  "grip-vertical",
  "group",
  "guitar",
  "ham",
  "hamburger",
  "hammer",
  "hand",
  "hand-coins",
  "hand-fist",
  "hand-grab",
  "hand-heart",
  "hand-helping",
  "hand-metal",
  "hand-platter",
  "handbag",
  "handshake",
  "hard-drive",
  "hard-drive-download",
  "hard-drive-upload",
  "hard-hat",
  "hash",
  "hat-glasses",
  "haze",
  "hd",
  "hdmi-port",
  "heading",
  "heading-1",
  "heading-2",
  "heading-3",
  "heading-4",
  "heading-5",
  "heading-6",
  "headphone-off",
  "headphones",
  "headset",
  "heart",
  "heart-crack",
  "heart-handshake",
  "heart-minus",
  "heart-off",
  "heart-plus",
  "heart-pulse",
  "heart-x",
  "heater",
  "helicopter",
  "help-circle",
  "helping-hand",
  "hexagon",
  "highlighter",
  "history",
  "home",
  "hop",
  "hop-off",
  "hospital",
  "hotel",
  "hourglass",
  "house",
  "house-heart",
  "house-plug",
  "house-plus",
  "house-wifi",
  "ice-cream",
  "ice-cream-2",
  "ice-cream-bowl",
  "ice-cream-cone",
  "id-card",
  "id-card-lanyard",
  "image",
  "image-down",
  "image-minus",
  "image-off",
  "image-play",
  "image-plus",
  "image-up",
  "image-upscale",
  "images",
  "import",
  "inbox",
  "indent",
  "indent-decrease",
  "indent-increase",
  "indian-rupee",
  "infinity",
  "info",
  "inspect",
  "inspection-panel",
  "italic",
  "iteration-ccw",
  "iteration-cw",
  "japanese-yen",
  "joystick",
  "kanban",
  "kanban-square",
  "kanban-square-dashed",
  "kayak",
  "key",
  "key-round",
  "key-square",
  "keyboard",
  "keyboard-music",
  "keyboard-off",
  "lamp",
  "lamp-ceiling",
  "lamp-desk",
  "lamp-floor",
  "lamp-wall-down",
  "lamp-wall-up",
  "land-plot",
  "landmark",
  "languages",
  "laptop",
  "laptop-2",
  "laptop-minimal",
  "laptop-minimal-check",
  "lasso",
  "lasso-select",
  "laugh",
  "layers",
  "layers-2",
  "layers-3",
  "layers-minus",
  "layers-plus",
  "layout",
  "layout-dashboard",
  "layout-grid",
  "layout-list",
  "layout-panel-left",
  "layout-panel-top",
  "layout-template",
  "leaf",
  "leafy-green",
  "lectern",
  "lens-concave",
  "lens-convex",
  "letter-text",
  "library",
  "library-big",
  "library-square",
  "life-buoy",
  "ligature",
  "lightbulb",
  "lightbulb-off",
  "line-chart",
  "line-dot-right-horizontal",
  "line-squiggle",
  "line-style",
  "link",
  "link-2",
  "link-2-off",
  "list",
  "list-check",
  "list-checks",
  "list-chevrons-down-up",
  "list-chevrons-up-down",
  "list-collapse",
  "list-end",
  "list-filter",
  "list-filter-plus",
  "list-indent-decrease",
  "list-indent-increase",
  "list-minus",
  "list-music",
  "list-ordered",
  "list-plus",
  "list-restart",
  "list-sort-ascending",
  "list-sort-descending",
  "list-start",
  "list-todo",
  "list-tree",
  "list-video",
  "list-x",
  "loader",
  "loader-2",
  "loader-circle",
  "loader-pinwheel",
  "locate",
  "locate-fixed",
  "locate-off",
  "location-edit",
  "lock",
  "lock-keyhole",
  "lock-keyhole-open",
  "lock-open",
  "log-in",
  "log-out",
  "logs",
  "lollipop",
  "luggage",
  "m-square",
  "magnet",
  "mail",
  "mail-check",
  "mail-minus",
  "mail-open",
  "mail-plus",
  "mail-question",
  "mail-question-mark",
  "mail-search",
  "mail-warning",
  "mail-x",
  "mailbox",
  "mails",
  "map",
  "map-minus",
  "map-pin",
  "map-pin-check",
  "map-pin-check-inside",
  "map-pin-house",
  "map-pin-minus",
  "map-pin-minus-inside",
  "map-pin-off",
  "map-pin-pen",
  "map-pin-plus",
  "map-pin-plus-inside",
  "map-pin-search",
  "map-pin-x",
  "map-pin-x-inside",
  "map-pinned",
  "map-plus",
  "mars",
  "mars-stroke",
  "martini",
  "maximize",
  "maximize-2",
  "medal",
  "megaphone",
  "megaphone-off",
  "meh",
  "memory-stick",
  "menu",
  "menu-square",
  "merge",
  "message-circle",
  "message-circle-check",
  "message-circle-code",
  "message-circle-dashed",
  "message-circle-heart",
  "message-circle-more",
  "message-circle-off",
  "message-circle-plus",
  "message-circle-question",
  "message-circle-question-mark",
  "message-circle-reply",
  "message-circle-warning",
  "message-circle-x",
  "message-square",
  "message-square-check",
  "message-square-code",
  "message-square-dashed",
  "message-square-diff",
  "message-square-dot",
  "message-square-heart",
  "message-square-lock",
  "message-square-more",
  "message-square-off",
  "message-square-plus",
  "message-square-quote",
  "message-square-reply",
  "message-square-share",
  "message-square-text",
  "message-square-warning",
  "message-square-x",
  "messages-square",
  "metronome",
  "mic",
  "mic-2",
  "mic-off",
  "mic-vocal",
  "microchip",
  "microscope",
  "microwave",
  "milestone",
  "milk",
  "milk-off",
  "minimize",
  "minimize-2",
  "minus",
  "minus-circle",
  "minus-square",
  "mirror-rectangular",
  "mirror-round",
  "monitor",
  "monitor-check",
  "monitor-cloud",
  "monitor-cog",
  "monitor-dot",
  "monitor-down",
  "monitor-off",
  "monitor-pause",
  "monitor-play",
  "monitor-smartphone",
  "monitor-speaker",
  "monitor-stop",
  "monitor-up",
  "monitor-x",
  "moon",
  "moon-star",
  "more-horizontal",
  "more-vertical",
  "motorbike",
  "mountain",
  "mountain-snow",
  "mouse",
  "mouse-left",
  "mouse-off",
  "mouse-pointer",
  "mouse-pointer-2",
  "mouse-pointer-2-off",
  "mouse-pointer-ban",
  "mouse-pointer-click",
  "mouse-pointer-square-dashed",
  "mouse-right",
  "move",
  "move-3-d",
  "move-3d",
  "move-diagonal",
  "move-diagonal-2",
  "move-down",
  "move-down-left",
  "move-down-right",
  "move-horizontal",
  "move-left",
  "move-right",
  "move-up",
  "move-up-left",
  "move-up-right",
  "move-vertical",
  "music",
  "music-2",
  "music-3",
  "music-4",
  "navigation",
  "navigation-2",
  "navigation-2-off",
  "navigation-off",
  "network",
  "newspaper",
  "nfc",
  "non-binary",
  "notebook",
  "notebook-pen",
  "notebook-tabs",
  "notebook-text",
  "notepad-text",
  "notepad-text-dashed",
  "nut",
  "nut-off",
  "octagon",
  "octagon-alert",
  "octagon-minus",
  "octagon-pause",
  "octagon-x",
  "omega",
  "option",
  "orbit",
  "origami",
  "outdent",
  "package",
  "package-2",
  "package-check",
  "package-minus",
  "package-open",
  "package-plus",
  "package-search",
  "package-x",
  "paint-bucket",
  "paint-roller",
  "paintbrush",
  "paintbrush-2",
  "paintbrush-vertical",
  "palette",
  "palmtree",
  "panda",
  "panel-bottom",
  "panel-bottom-close",
  "panel-bottom-dashed",
  "panel-bottom-inactive",
  "panel-bottom-open",
  "panel-left",
  "panel-left-close",
  "panel-left-dashed",
  "panel-left-inactive",
  "panel-left-open",
  "panel-left-right-dashed",
  "panel-right",
  "panel-right-close",
  "panel-right-dashed",
  "panel-right-inactive",
  "panel-right-open",
  "panel-top",
  "panel-top-bottom-dashed",
  "panel-top-close",
  "panel-top-dashed",
  "panel-top-inactive",
  "panel-top-open",
  "panels-left-bottom",
  "panels-left-right",
  "panels-right-bottom",
  "panels-top-bottom",
  "panels-top-left",
  "paper-bag",
  "paperclip",
  "parasol",
  "parentheses",
  "parking-circle",
  "parking-circle-off",
  "parking-meter",
  "parking-square",
  "parking-square-off",
  "party-popper",
  "pause",
  "pause-circle",
  "pause-octagon",
  "paw-print",
  "pc-case",
  "pen",
  "pen-box",
  "pen-line",
  "pen-off",
  "pen-square",
  "pen-tool",
  "pencil",
  "pencil-line",
  "pencil-off",
  "pencil-ruler",
  "pencil-sparkles",
  "pentagon",
  "percent",
  "percent-circle",
  "percent-diamond",
  "percent-square",
  "person-standing",
  "phi",
  "philippine-peso",
  "phone",
  "phone-call",
  "phone-forwarded",
  "phone-incoming",
  "phone-missed",
  "phone-off",
  "phone-outgoing",
  "pi",
  "pi-square",
  "piano",
  "pickaxe",
  "picture-in-picture",
  "picture-in-picture-2",
  "pie-chart",
  "piggy-bank",
  "pilcrow",
  "pilcrow-left",
  "pilcrow-right",
  "pilcrow-square",
  "pill",
  "pill-bottle",
  "pin",
  "pin-off",
  "pipette",
  "pizza",
  "plane",
  "plane-landing",
  "plane-takeoff",
  "play",
  "play-circle",
  "play-off",
  "play-square",
  "plug",
  "plug-2",
  "plug-zap",
  "plug-zap-2",
  "plus",
  "plus-circle",
  "plus-square",
  "pocket-knife",
  "podcast",
  "podium",
  "pointer",
  "pointer-off",
  "popcorn",
  "popsicle",
  "pound-sterling",
  "power",
  "power-circle",
  "power-off",
  "power-square",
  "presentation",
  "printer",
  "printer-check",
  "printer-x",
  "projector",
  "proportions",
  "puzzle",
  "pyramid",
  "qr-code",
  "quote",
  "rabbit",
  "radar",
  "radiation",
  "radical",
  "radio",
  "radio-off",
  "radio-receiver",
  "radio-tower",
  "radius",
  "rainbow",
  "rat",
  "ratio",
  "receipt",
  "receipt-cent",
  "receipt-euro",
  "receipt-indian-rupee",
  "receipt-japanese-yen",
  "receipt-pound-sterling",
  "receipt-russian-ruble",
  "receipt-swiss-franc",
  "receipt-text",
  "receipt-turkish-lira",
  "rectangle-circle",
  "rectangle-ellipsis",
  "rectangle-goggles",
  "rectangle-horizontal",
  "rectangle-vertical",
  "recycle",
  "redo",
  "redo-2",
  "redo-dot",
  "refresh-ccw",
  "refresh-ccw-dot",
  "refresh-cw",
  "refresh-cw-off",
  "refrigerator",
  "regex",
  "remove-formatting",
  "repeat",
  "repeat-1",
  "repeat-2",
  "repeat-off",
  "replace",
  "replace-all",
  "reply",
  "reply-all",
  "rewind",
  "ribbon",
  "road",
  "rocket",
  "rocking-chair",
  "roller-coaster",
  "rose",
  "rotate-3-d",
  "rotate-3d",
  "rotate-ccw",
  "rotate-ccw-key",
  "rotate-ccw-square",
  "rotate-cw",
  "rotate-cw-square",
  "route",
  "route-off",
  "router",
  "rows",
  "rows-2",
  "rows-3",
  "rows-4",
  "rss",
  "ruler",
  "ruler-dimension-line",
  "russian-ruble",
  "sailboat",
  "salad",
  "sandwich",
  "satellite",
  "satellite-dish",
  "saudi-riyal",
  "save",
  "save-all",
  "save-check",
  "save-off",
  "save-pen",
  "save-plus",
  "scale",
  "scale-3-d",
  "scale-3d",
  "scaling",
  "scan",
  "scan-barcode",
  "scan-box",
  "scan-eye",
  "scan-face",
  "scan-heart",
  "scan-line",
  "scan-qr-code",
  "scan-search",
  "scan-text",
  "scatter-chart",
  "school",
  "school-2",
  "scissors",
  "scissors-line-dashed",
  "scissors-square",
  "scissors-square-dashed-bottom",
  "scooter",
  "screen-share",
  "screen-share-off",
  "scroll",
  "scroll-text",
  "search",
  "search-alert",
  "search-check",
  "search-code",
  "search-slash",
  "search-x",
  "section",
  "send",
  "send-horizonal",
  "send-horizontal",
  "send-to-back",
  "separator-horizontal",
  "separator-vertical",
  "server",
  "server-cog",
  "server-crash",
  "server-off",
  "server-plus",
  "settings",
  "settings-2",
  "shapes",
  "share",
  "share-2",
  "sheet",
  "shell",
  "shelving-unit",
  "shield",
  "shield-alert",
  "shield-ban",
  "shield-check",
  "shield-close",
  "shield-cog",
  "shield-cog-corner",
  "shield-ellipsis",
  "shield-half",
  "shield-keyhole",
  "shield-minus",
  "shield-off",
  "shield-plus",
  "shield-question",
  "shield-question-mark",
  "shield-user",
  "shield-x",
  "ship",
  "ship-wheel",
  "shirt",
  "shopping-bag",
  "shopping-basket",
  "shopping-cart",
  "shovel",
  "shower-head",
  "shredder",
  "shrimp",
  "shrink",
  "shrub",
  "shuffle",
  "sidebar",
  "sidebar-close",
  "sidebar-open",
  "sigma",
  "sigma-square",
  "signal",
  "signal-high",
  "signal-low",
  "signal-medium",
  "signal-zero",
  "signature",
  "signpost",
  "signpost-big",
  "siren",
  "skip-back",
  "skip-forward",
  "skull",
  "slash",
  "slash-square",
  "slice",
  "sliders",
  "sliders-horizontal",
  "sliders-vertical",
  "smartphone",
  "smartphone-charging",
  "smartphone-nfc",
  "smile",
  "smile-plus",
  "snail",
  "snowflake",
  "soap-dispenser-droplet",
  "sofa",
  "solar-panel",
  "sort-asc",
  "sort-desc",
  "soup",
  "space",
  "spade",
  "sparkle",
  "sparkles",
  "speaker",
  "speech",
  "spell-check",
  "spell-check-2",
  "spline",
  "spline-pointer",
  "split",
  "split-square-horizontal",
  "split-square-vertical",
  "spool",
  "sport-shoe",
  "spotlight",
  "spray-can",
  "sprout",
  "square",
  "square-activity",
  "square-arrow-down",
  "square-arrow-down-left",
  "square-arrow-down-right",
  "square-arrow-left",
  "square-arrow-out-down-left",
  "square-arrow-out-down-right",
  "square-arrow-out-up-left",
  "square-arrow-out-up-right",
  "square-arrow-right",
  "square-arrow-right-enter",
  "square-arrow-right-exit",
  "square-arrow-up",
  "square-arrow-up-left",
  "square-arrow-up-right",
  "square-asterisk",
  "square-bottom-dashed-scissors",
  "square-centerline-dashed-horizontal",
  "square-centerline-dashed-vertical",
  "square-chart-gantt",
  "square-check",
  "square-check-big",
  "square-chevron-down",
  "square-chevron-left",
  "square-chevron-right",
  "square-chevron-up",
  "square-code",
  "square-dashed",
  "square-dashed-bottom",
  "square-dashed-bottom-code",
  "square-dashed-kanban",
  "square-dashed-mouse-pointer",
  "square-dashed-text",
  "square-dashed-top-solid",
  "square-divide",
  "square-dot",
  "square-equal",
  "square-function",
  "square-gantt-chart",
  "square-kanban",
  "square-library",
  "square-m",
  "square-menu",
  "square-minus",
  "square-mouse-pointer",
  "square-parking",
  "square-parking-off",
  "square-pause",
  "square-pen",
  "square-percent",
  "square-pi",
  "square-pilcrow",
  "square-play",
  "square-plus",
  "square-power",
  "square-radical",
  "square-round-corner",
  "square-scissors",
  "square-sigma",
  "square-slash",
  "square-split-horizontal",
  "square-split-vertical",
  "square-square",
  "square-stack",
  "square-star",
  "square-stop",
  "square-terminal",
  "square-user",
  "square-user-round",
  "square-x",
  "squares-exclude",
  "squares-intersect",
  "squares-subtract",
  "squares-unite",
  "squircle",
  "squircle-dashed",
  "squirrel",
  "stamp",
  "star",
  "star-check",
  "star-half",
  "star-minus",
  "star-off",
  "star-plus",
  "star-x",
  "stars",
  "step-back",
  "step-forward",
  "stethoscope",
  "sticker",
  "sticky-note",
  "sticky-note-check",
  "sticky-note-minus",
  "sticky-note-off",
  "sticky-note-plus",
  "sticky-note-x",
  "sticky-notes",
  "stone",
  "stop-circle",
  "store",
  "stretch-horizontal",
  "stretch-vertical",
  "strikethrough",
  "subscript",
  "subtitles",
  "summary",
  "sun",
  "sun-dim",
  "sun-medium",
  "sun-moon",
  "sun-snow",
  "sunrise",
  "sunset",
  "superscript",
  "swatch-book",
  "swiss-franc",
  "switch-camera",
  "sword",
  "swords",
  "syringe",
  "table",
  "table-2",
  "table-cells-merge",
  "table-cells-split",
  "table-columns-split",
  "table-config",
  "table-of-contents",
  "table-properties",
  "table-rows-split",
  "tablet",
  "tablet-smartphone",
  "tablets",
  "tag",
  "tag-plus",
  "tag-x",
  "tags",
  "tally-1",
  "tally-2",
  "tally-3",
  "tally-4",
  "tally-5",
  "tangent",
  "target",
  "telescope",
  "tent",
  "tent-tree",
  "terminal",
  "terminal-square",
  "test-tube",
  "test-tube-2",
  "test-tube-diagonal",
  "test-tubes",
  "text",
  "text-align-center",
  "text-align-end",
  "text-align-justify",
  "text-align-start",
  "text-cursor",
  "text-cursor-input",
  "text-initial",
  "text-quote",
  "text-search",
  "text-select",
  "text-selection",
  "text-wrap",
  "theater",
  "thermometer",
  "thermometer-snowflake",
  "thermometer-sun",
  "thumbs-down",
  "thumbs-up",
  "ticket",
  "ticket-check",
  "ticket-minus",
  "ticket-percent",
  "ticket-plus",
  "ticket-slash",
  "ticket-x",
  "tickets",
  "tickets-plane",
  "timeline",
  "timer",
  "timer-off",
  "timer-reset",
  "toggle-left",
  "toggle-right",
  "toilet",
  "tool-case",
  "toolbox",
  "tornado",
  "torus",
  "touchpad",
  "touchpad-off",
  "towel-rack",
  "tower-control",
  "toy-brick",
  "tractor",
  "traffic-cone",
  "train",
  "train-front",
  "train-front-tunnel",
  "train-track",
  "tram-front",
  "transgender",
  "trash",
  "trash-2",
  "tree-deciduous",
  "tree-palm",
  "tree-pine",
  "trees",
  "trending-down",
  "trending-up",
  "trending-up-down",
  "triangle",
  "triangle-alert",
  "triangle-dashed",
  "triangle-right",
  "trophy",
  "truck",
  "truck-electric",
  "turkish-lira",
  "turntable",
  "turtle",
  "tv",
  "tv-2",
  "tv-minimal",
  "tv-minimal-play",
  "type",
  "type-outline",
  "umbrella",
  "umbrella-off",
  "underline",
  "undo",
  "undo-2",
  "undo-dot",
  "unfold-horizontal",
  "unfold-vertical",
  "ungroup",
  "university",
  "unlink",
  "unlink-2",
  "unlock",
  "unlock-keyhole",
  "unplug",
  "upload",
  "upload-cloud",
  "usb",
  "user",
  "user-2",
  "user-check",
  "user-check-2",
  "user-circle",
  "user-circle-2",
  "user-cog",
  "user-cog-2",
  "user-key",
  "user-lock",
  "user-minus",
  "user-minus-2",
  "user-pen",
  "user-plus",
  "user-plus-2",
  "user-round",
  "user-round-arrow-left",
  "user-round-check",
  "user-round-cog",
  "user-round-key",
  "user-round-minus",
  "user-round-pen",
  "user-round-plus",
  "user-round-search",
  "user-round-x",
  "user-search",
  "user-square",
  "user-square-2",
  "user-star",
  "user-x",
  "user-x-2",
  "users",
  "users-2",
  "users-round",
  "utensils",
  "utensils-crossed",
  "utility-pole",
  "van",
  "variable",
  "vault",
  "vector-square",
  "vegan",
  "venetian-mask",
  "venus",
  "venus-and-mars",
  "verified",
  "vibrate",
  "vibrate-off",
  "video",
  "video-off",
  "videotape",
  "view",
  "voicemail",
  "volleyball",
  "volume",
  "volume-1",
  "volume-2",
  "volume-off",
  "volume-x",
  "vote",
  "wallet",
  "wallet-2",
  "wallet-cards",
  "wallet-minimal",
  "wallpaper",
  "wand",
  "wand-2",
  "wand-sparkles",
  "warehouse",
  "washing-machine",
  "watch",
  "waves",
  "waves-arrow-down",
  "waves-arrow-up",
  "waves-horizontal",
  "waves-ladder",
  "waves-vertical",
  "waypoints",
  "webcam",
  "webcam-off",
  "webhook",
  "webhook-off",
  "weight",
  "weight-tilde",
  "wheat",
  "wheat-off",
  "whole-word",
  "wifi",
  "wifi-cog",
  "wifi-high",
  "wifi-low",
  "wifi-off",
  "wifi-pen",
  "wifi-sync",
  "wifi-zero",
  "wind",
  "wind-arrow-down",
  "wine",
  "wine-off",
  "workflow",
  "worm",
  "wrap-text",
  "wrench",
  "wrench-off",
  "x",
  "x-circle",
  "x-line-top",
  "x-octagon",
  "x-square",
  "zap",
  "zap-off",
  "zodiac-aquarius",
  "zodiac-aries",
  "zodiac-cancer",
  "zodiac-capricorn",
  "zodiac-gemini",
  "zodiac-leo",
  "zodiac-libra",
  "zodiac-ophiuchus",
  "zodiac-pisces",
  "zodiac-sagittarius",
  "zodiac-scorpio",
  "zodiac-taurus",
  "zodiac-virgo",
  "zoom-in",
  "zoom-out",
] as const;
export type IconNames = (typeof IconNames)[number];
